import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import VisitingObjectsSearch from './index';

const VoSearchShadowRoot = ({ clientPublicToken, ui = {}, editorMode = false, demoMode = false, hideTrigger = false }) => {
  const shadowRootRef = useRef(null);

  useEffect(() => {
    // Create shadow root container
    const container = document.createElement('div');
    container.className = 'vo-search-shadow-root';
    document.body.appendChild(container);

    // Create shadow root
    const shadowRoot = container.attachShadow({ mode: 'open' });
    shadowRootRef.current = shadowRoot;

    // Create root for React
    const root = createRoot(shadowRoot);

    // Render search component
    root.render(
      <VisitingObjectsSearch
        clientPublicToken={clientPublicToken}
        ui={ui}
        editorMode={editorMode}
        demoMode={demoMode}
        hideTrigger={hideTrigger}
      />
    );

    return () => {
      root.unmount();
      container.remove();
    };
  }, [clientPublicToken, ui, editorMode, demoMode]);

  return null;
};

export default VoSearchShadowRoot; 